import { cva, type VariantProps } from 'class-variance-authority';

import { badgeVariants } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

/** 상태 tone — 의미 이름(shadcn 시맨틱 + 확장 상태색). 도메인 상태→tone 매핑은 각 feature 가 소유. */
const toneVariants = cva('gap-1 whitespace-nowrap [&_svg]:size-3.5', {
  variants: {
    tone: {
      neutral: 'border-transparent bg-muted text-muted-foreground',
      info: 'border-transparent bg-accent text-accent-foreground',
      primary: 'border-primary/30 text-primary',
      success: 'border-success/20 bg-success/10 text-success',
      warning: 'border-warning/20 bg-warning/10 text-warning',
      destructive: 'border-destructive/20 bg-destructive/10 text-destructive',
      solid: 'border-transparent bg-primary text-primary-foreground',
    },
  },
  defaultVariants: { tone: 'neutral' },
});

export type StatusTone = NonNullable<VariantProps<typeof toneVariants>['tone']>;
export type StatusTagProps = React.ComponentProps<'span'> & VariantProps<typeof toneVariants>;

/**
 * 상태 태그 — Admin Kit Badge(outline) 형태에 tone 색만 얹는다.
 * `span` 으로 렌더한다(Badge 원본은 div — 버튼·문단 안에 들어가는 자리가 있어 인라인 요소가 필요).
 */
export function StatusTag({ tone, className, ...props }: StatusTagProps) {
  return (
    <span
      className={cn(badgeVariants({ variant: 'outline' }), toneVariants({ tone }), className)}
      {...props}
    />
  );
}
